import { uid } from 'radash'
import { CheckBox, CheckBoxContainer, CheckBoxProps } from '~components/ui/control/check-box'
import { cn } from '~utils/cn'

type CheckBoxItemProps = Readonly<
  Omit<CheckBoxProps, 'value'> & {
    value: string | number | boolean
    label: string
    withTextField?: boolean
  }
>

const CheckBoxItem = ({
  disabled,
  checked,
  value,
  label,
  onChange,
  withTextField,
}: CheckBoxItemProps) => {
  const id = uid(10)
  const formattedValue = typeof value === 'boolean' ? Number(value) : value

  return (
    <CheckBoxContainer
      disabled={disabled}
      htmlFor={id}
      className={cn(
        'w-full rounded-lg',
        checked && !withTextField && 'bg-white dark:bg-inherit',
        !withTextField && 'px-4 py-3'
      )}
    >
      <CheckBox
        disabled={disabled}
        checked={checked}
        value={formattedValue}
        id={id}
        onChange={onChange}
      />
      <span className="ml-4 text-gray-700 text-body-1 dark:text-gray-500">{label}</span>
    </CheckBoxContainer>
  )
}

export default CheckBoxItem
